import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "row w-full justify-between flex" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_9 = { class: "flex flex-col h-full" }
const _hoisted_10 = { class: "flex-1 overflow-auto" }
const _hoisted_11 = { class: "popup-business" }
const _hoisted_12 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_13 = { class: "formcontainer flex flex-col" }
const _hoisted_14 = { disabled: true }
const _hoisted_15 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_18 = { class: "w-3/6" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "w-3/6 leftspacing" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_23 = { class: "w-3/6" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "w-3/6 leftspacing" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_28 = { class: "w-3/6" }
const _hoisted_29 = { class: "w-3/6 leftspacing" }
const _hoisted_30 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_34 = { class: "w-3/6" }
const _hoisted_35 = { class: "w-3/6 leftspacing" }
const _hoisted_36 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = {
  key: 0,
  class: "row flex flex-row w-full upperspacing"
}
const _hoisted_39 = { class: "w-full" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Request Approvals")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex", _ctx.tableRows.length == 0?'btndisabled pointer-events-none':'filterButton']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.tableRows.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[11] || (_cache[11] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mt-3 text-xs" }, " The Global Risks Report 2022, 17th Edition, is published by the World Economic Forum. The information in this report, or on which this report is based, has been obtained from sources that the authors believe to be reliable and accurate. However, it has not been independently verified and no representation or warranty, express or implied, is made as to the accuracy or completeness of any information obtained from third parties. ", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.tableRows,
        headersData: _ctx.headers,
        openPopup: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.approvalStatusDetails)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.approvalStatusDetails
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Request Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("fieldset", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[15] || (_cache[15] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Risk", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "inputboxstyling",
                                placeholder: "Risk",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.riskObjShow.risk) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.riskObjShow.risk,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "ID", -1)),
                                _createElementVNode("input", {
                                  class: "inputboxstyling",
                                  value: _ctx.riskObjShow.taskId,
                                  disabled: ""
                                }, null, 8, _hoisted_19)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "controllabel" }, "Sub-Category", -1)),
                                _createElementVNode("input", {
                                  class: "inputboxstyling",
                                  value: _ctx.riskObjShow.subCategory,
                                  disabled: ""
                                }, null, 8, _hoisted_21)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", null, [
                                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Tier", -1)),
                                _createElementVNode("input", {
                                  class: "inputboxstyling",
                                  value: _ctx.riskObjShow.tier,
                                  disabled: ""
                                }, null, 8, _hoisted_24)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", null, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Target", -1)),
                                _createElementVNode("input", {
                                  class: "inputboxstyling",
                                  value: _ctx.riskObjShow.target,
                                  disabled: ""
                                }, null, 8, _hoisted_26)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", null, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel" }, "Risk Severity", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskObjShow.severity,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.riskObjShow.severity) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel" }, "Status", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskObjShow.status,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.riskObjShow.status) = $event)),
                                  options: _ctx.requestStatus,
                                  disabled: "",
                                  optionLabel: "value",
                                  optionValue: "id",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", null, [
                                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                                _createElementVNode("input", {
                                  class: "inputboxstyling",
                                  value: _ctx.riskObjShow.riskOwnerName,
                                  disabled: ""
                                }, null, 8, _hoisted_32)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", null, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskObjShow.likelihood,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.riskObjShow.likelihood) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", null, [
                                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Impact", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskObjShow.impact,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.riskObjShow.impact) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _cache[25] || (_cache[25] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Justification", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "inputboxstyling h-24",
                                placeholder: "Justification",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.riskObjShow.comments) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.riskObjShow.comments,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ])
                        ]),
                        (_ctx.riskObjShow.status == 10408 || ((_ctx.riskObjShow.status == 10403 || _ctx.riskObjShow.status == 10410)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", {
                                  for: "Risk",
                                  class: "controllabel"
                                }, "Comments", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  class: _normalizeClass(["inputboxstyling h-24", {
                                                    'is-invalid': (_ctx.v$.riskObjShow.approverComments.$error),
                                                    'disabledinputboxstyling pointer-events-none' :(_ctx.presentTableRow.approvalStatus == 10403 || _ctx.presentTableRow.approvalStatus == 10410 )
                                                }]),
                                  placeholder: "Comments",
                                  disabled: _ctx.presentTableRow.approvalStatus == 10403 || _ctx.presentTableRow.approvalStatus == 10410,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.riskObjShow.approverComments) = $event))
                                }, null, 10, _hoisted_40), [
                                  [
                                    _vModelText,
                                    _ctx.riskObjShow.approverComments,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.riskObjShow.approverComments.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      (_ctx.v$.riskObjShow.approverComments.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.presentTableRow.approvalStatus != 10403 && _ctx.presentTableRow.approvalStatus!= 10410)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("button", {
                        class: _normalizeClass(_ctx.riskObjShow.approverComments?'mr-3 rounded font-bold text-sm px-5 h-7 leading-[normal] border border-darkred flex justify-center items-center text-darkred':'mr-3 btndisabled'),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.approveStatus('rejected',_ctx.riskObjShow)))
                      }, "Reject", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(_ctx.riskObjShow.approverComments?'bg-primary rounded font-bold text-sm px-5 h-7 leading-[normal] border flex justify-center items-center text-white':'btndisabled'),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.approveStatus('approved',_ctx.riskObjShow)))
                      }, "Approve", 2)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}